import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';
import moment from 'moment';
import UserContext from '../../../hooks/UserContext';

const styles = css`
display: flex;
flex-direction: column;
gap: 20px;
width: 100%;
align-content: center;

> .events {
  display: flex;
  flex-direction: column;

    > .event {
    display: flex;
    flex-direction: column;
    gap: 5px;
    border-bottom: 1px solid #dddddd;
    padding: 5px;
    padding-top: 7px;
    padding-bottom: 7px;
    
    > .title {
      display: grid;
      grid-template-columns: auto 1fr;
      gap: 10px;
      flex-wrap: wrap;
      justify-content: space-between;
      font-weight: bold;
      font-style: italic;
    }
    > .row {
      display: flex;
      flex-wrap: wrap;
      font-size: 0.85em;
      gap: 5px;
    }

    & .label {
      font-weight: bold;
    }
   }
}

`;

const EventPanel = styled(({ className, group }) => {
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const isOwner = group?.owner?._id === user?._id;
  const isAdmin = group?.admins?.find(adminId => adminId === user?._id);

  if (!group) return null;

  const EventCard = ({ event }) => {

    return (
      <div className='event'>
        <div className='title'>
          <div className='date'>
            {moment(event.date).format('ddd MMM DD YYYY')}
          </div>
          <div className='name'>
            {event.name}
          </div>
        </div>
        <div className='row'>
          <div className='label'>
            Gifts for:
          </div>
          {event.recipients.map(recipient => recipient.firstname).join(', ')}
        </div>
        {
          event.location &&
          <div className='row'>
            <div className='label'>
              Location:
            </div>
            {event.location}
          </div>
        }
        {
          event.notes &&
          <div className='row'>
            <div className='label'>
              Notes:
            </div>
            <div classNam>
              {event.notes}
            </div>
          </div>
        }
      </div>
    )
  }

  return (
    <div className={className}>
      <div className='events'>
        {group.events.map((event, i) => <EventCard key={i} event={event} />)}
      </div>
      {
        (isOwner || isAdmin) &&
        <div className='buttons'>
          <button className='primary' onClick={() => navigate(`/events/new`, { state: { group } })}>Add Event</button>
        </div>
      }
    </div>
  )
})`${styles}`

export default EventPanel;